module.exports = __webpack_public_path__ + "static/media/logo-icon.bd3a5aef.svg";